import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import ModalShell from "../Modal/ModalShell";
import { subscribeErrors } from "../../services/errorBus";

export default function GlobalErrorModal() {
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);
  useEffect(() => subscribeErrors((payload) => {
    setError(payload);
    setCopied(false);
    setCopyFailed(false);
  }), []);

  const close = () => setError(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(error?.detail || error?.message || "");
      setCopied(true);
      setCopyFailed(false);
    } catch {
      setCopyFailed(true);
    }
  };

  return (
    <ModalShell
      visible={!!error}
      onHide={close}
      title="No se pudo completar la operación"
      width="30rem"
      className="teamassess-error-dialog"
      footer={<Button type="button" label="Entendido" onClick={close} autoFocus />}
    >
      <p className="ta-error-message" role="alert">{error?.message}</p>
      {error?.detail && (
        <details className="ta-error-details" key={error.id}>
          <summary>Detalles técnicos</summary>
          <pre>{error.detail}</pre>
          <Button type="button" icon="pi pi-copy" label="Copiar detalles" text onClick={copy} />
          <span className="ta-copy-status" role="status">
            {copyFailed ? "No se pudo copiar. Puedes seleccionar el texto." : copied ? "Detalles copiados." : ""}
          </span>
        </details>
      )}
    </ModalShell>
  );
}
